import { Phone, User } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const MiniVoiceIllustration = () => {
  const { t } = useLanguage();
  return (
        <div className="relative w-full mx-auto">
      {/* Phone Interface */}
      <div className="bg-card rounded-2xl shadow-lg border border-border p-6 space-y-6">
        {/* Header */}
        <div className="text-center space-y-2">
          <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mx-auto animate-pulse-slow">
            <Phone className="w-8 h-8 text-primary" />
          </div>
          <div>
            <div className="text-sm font-semibold">{t.miniIllustrations.voice.header}</div>
            <div className="text-xs text-muted-foreground">{t.miniIllustrations.voice.status}</div>
          </div>
        </div>

        {/* Sound Waves */}
        <div className="flex items-center justify-center gap-1 h-16">
          {[...Array(5)].map((_, i) => (
            <div
              key={i}
              className="w-1 bg-primary/60 rounded-full animate-sound-wave"
              style={{
                animationDelay: `${i * 0.1}s`,
                height: i === 2 ? "100%" : i === 1 || i === 3 ? "70%" : "40%",
              }}
            />
          ))}
        </div>

        {/* Status Text */}
        <div className="text-center">
          <p className="text-xs text-muted-foreground animate-fade-in">
            "{t.miniIllustrations.voice.message}"
          </p>
        </div>
      </div>
    </div>
  );
};

export default MiniVoiceIllustration;
